<script lang="ts">
	import { locationQuery } from "@stores/searchQuery";
	import { createEventDispatcher } from "svelte";
	import LocationSuggestion from "./LocationSuggestion.svelte";
	import { filteredPlaces } from "./store";

	export let shadow = "shadow-lg";

	const dispatch = createEventDispatcher<{
		blur: FocusEvent;
		click: {
			placeName: string;
			municipalityIndex: number;
			provinceIndex: number;
		};
	}>();

	$: suggestions = $filteredPlaces.slice(0, 5);
</script>

<div class="w-full overflow-hidden rounded-lg bg-white {shadow}">
	{#if suggestions.length > 0}
		{#each suggestions as [placeName, municipalityIndex, provinceIndex]}
			<LocationSuggestion
				{placeName}
				{municipalityIndex}
				{provinceIndex}
				on:blur
				on:click={() => {
					dispatch("click", {
						placeName,
						municipalityIndex,
						provinceIndex
					});
				}}
			/>
		{/each}
	{:else if $locationQuery !== ""}
		<div class="p-3 text-sm text-gray-500">Geen resultaten gevonden</div>
	{/if}
</div>
